export const LIMIT = 5;
export const POLL_INTERVAL = 1000 * 3;
